import React from 'react';

import {ActionOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import Tooltip from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import runModal from 'ui-library/runModal';

import DeleteContainerContentsModal from './DeleteContainerContentsModal';

interface Props {
  buttonStyle: ButtonStyle;
  className?: string;
  containerIds: Array<string>;
  disabled: boolean;
  actionOrigin: ActionOrigin;
  // This callback aims to track user clicks.
  onClickTracking?: () => void;
}

class DeleteContainerContentsButton extends React.Component<Props> {
  static defaultProps = {
    buttonStyle: ButtonStyle.TERTIARY_BLUE,
    disabled: false,
  };

  _handleClick = (): void => {
    this.props.onClickTracking?.();
    runModal(DeleteContainerContentsModal, {
      containerIds: this.props.containerIds,
      actionOrigin: this.props.actionOrigin,
    });
  };

  render(): JSX.Element {
    return (
      <Tooltip title="Remove contents">
        <Button
          buttonStyle={this.props.buttonStyle}
          className={this.props.className}
          disabled={this.props.disabled}
          icon="remove-contents"
          onClick={this._handleClick}
          size={ButtonSize.SMALL}
          dataTestAttrs={{component: 'DeleteContainerContentsButton', element: 'button'}}
        />
      </Tooltip>
    );
  }
}

export default DeleteContainerContentsButton;
